import React from 'react';
import { LayoutDashboard, Brain, Library, Settings, MoreVertical, Users } from 'lucide-react';
import { cn } from '../lib/utils';
import { Button } from './ui/Button';
import { Avatar, AvatarFallback, AvatarImage } from './ui/Avatar';
import { Card } from './ui/Card';
type ActiveTab = 'dashboard' | 'brain' | 'swipefile' | 'profiles' | 'settings';
interface SidebarProps {
  className?: string;
  activeTab: ActiveTab;
  onTabChange: (tab: ActiveTab) => void;
}
export function Sidebar({
  className,
  activeTab,
  onTabChange
}: SidebarProps) {
  const navItems = [{
    icon: LayoutDashboard,
    label: 'Dashboard',
    id: 'dashboard' as ActiveTab
  }, {
    icon: Brain,
    label: 'Brain',
    id: 'brain' as ActiveTab
  }, {
    icon: Library,
    label: 'Swipefile',
    id: 'swipefile' as ActiveTab
  }, {
    icon: Users,
    label: 'Profiles',
    id: 'profiles' as ActiveTab
  }, {
    icon: Settings,
    label: 'Settings',
    id: 'settings' as ActiveTab
  }];
  return <div className={cn('flex flex-col h-full w-[280px] border-r bg-white flex-shrink-0', className)} data-id="element-569">
      {/* Logo Area */}
      <div className="p-6" data-id="element-570">
        <div className="flex items-center gap-2" data-id="element-571">
          <div className="h-8 w-8 rounded-lg bg-[#139191] flex items-center justify-center" data-id="element-572">
            <Brain className="h-5 w-5 text-white" data-id="element-573" />
          </div>
          <span className="font-bold text-xl tracking-tight" data-id="element-574">
            Content Engine
          </span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-4 space-y-2 py-4" data-id="element-575">
        {navItems.map(item => <Button key={item.id} variant="ghost" onClick={() => onTabChange(item.id)} className={cn('w-full justify-start gap-3 h-12 text-base font-medium', activeTab === item.id ? 'bg-[#139191] text-white hover:bg-[#139191]/90 hover:text-white' : 'text-gray-600 hover:bg-[#139191]/10 hover:text-[#139191]')} data-id="element-576">
            <item.icon className="h-5 w-5" data-id="element-577" />
            {item.label}
          </Button>)}
      </nav>

      {/* User Profile */}
      <div className="p-4 mt-auto" data-id="element-578">
        <Card className="p-3 flex items-center gap-3 border shadow-sm hover:shadow-md transition-shadow cursor-pointer" data-id="element-579">
          <Avatar className="h-10 w-10 border-2 border-white shadow-sm" data-id="element-580">
            <AvatarImage src="https://github.com/shadcn.png" alt="User" data-id="element-581" />
            <AvatarFallback data-id="element-582">JD</AvatarFallback>
          </Avatar>
          <div className="flex-1 min-w-0" data-id="element-583">
            <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-584">
              Jane Doe
            </p>
            <p className="text-xs text-gray-500 truncate" data-id="element-585">
              jane@contentengine.com
            </p>
          </div>
          <MoreVertical className="h-4 w-4 text-gray-400" data-id="element-586" />
        </Card>
      </div>
    </div>;
}